import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import HowItWorks from "./components/HowItWorks";
import Reviews from "./components/Reviews";
import CustomerFilter from "./components/CustomerFilter";
import CallToAction from "./components/CallToAction";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";

// Pagine quartieri
import AssistenzaCondizionatoriRoma from "./components/AssistenzaCondizionatoriRoma";
import IdraulicoRomaNordParioli from "./components/IdraulicoRomaNordParioli";
import ProntoInterventoRomaCentroZTL from "./components/ProntoInterventoRomaCentroZTL";
import ElettricististaRomaEUR from "./components/ElettricististaRomaEUR";
import RiparazioniCaldaiePrati from "./components/RiparazioniCaldaiePrati";
import IdraulicoRomaEstCentocelle from "./components/IdraulicoRomaEstCentocelle";
import ProntoInterventoMonteverde from "./components/ProntoInterventoMonteverde";
import ElettricistaSanGiovanni from "./components/ElettricistaSanGiovanni";
import RiparazioniCaldaieAurelio from "./components/RiparazioniCaldaieAurelio";
import SOSCasaTrastevereZTL from "./components/SOSCasaTrastevereZTL";

// Pagine servizio principali - alta conversione
import IdraulicoRomaPrati from "./components/IdraulicoRomaPrati";
import IdraulicoUrgenteRoma from "./components/IdraulicoUrgenteRoma";
import ElettricistaCentroRoma from "./components/ElettricistaCentroRoma";

// Nuove pagine quartiere - conversione massima
import IdraulicoRomaEUR from "./components/IdraulicoRomaEUR";
import IdraulicoRomaParioli from "./components/IdraulicoRomaParioli";
import IdraulicoRomaTrastevere from "./components/IdraulicoRomaTrastevere";
import IdraulicoRomaTiburtina from "./components/IdraulicoRomaTiburtina";
import IdraulicoRomaCasilina from "./components/IdraulicoRomaCasilina";
import ElettricistRomaNord from "./components/ElettricistRomaNord";
import ElettricistRomaSud from "./components/ElettricistRomaSud";
import ProntoInterventoRomaCentro from "./components/ProntoInterventoRomaCentro";
import ProntoInterventoRomaNord from "./components/ProntoInterventoRomaNord";
import ProntoInterventoRomaSud from "./components/ProntoInterventoRomaSud";

// Articoli blog
import BlogGalleggianteGeberit from "./components/BlogGalleggianteGeberit";
import BlogCaldaiaErroreE01 from "./components/BlogCaldaiaErroreE01";
import BlogPerditaAcquaLavandino from "./components/BlogPerditaAcquaLavandino";
import BlogPuliziaFiltriCondizionatore from "./components/BlogPuliziaFiltriCondizionatore";
import BlogSalvavitaPiove from "./components/BlogSalvavitaPiove";

// Nuovi articoli blog - alta conversione
import BlogPerditaAcquaCosaFare from "./components/BlogPerditaAcquaCosaFare";
import BlogCaldaiaRottaCosaFare from "./components/BlogCaldaiaRottaCosaFare";
import BlogSalvavitaScattaCosaFare from "./components/BlogSalvavitaScattaCosaFare";

const Home = () => {
  return (
    <>
      <Helmet>
        <link rel="canonical" href={`${window.location.origin}/`} />
      </Helmet>
      <div className="min-h-screen">
        <Header />
        <Hero />
        <Services />
        <HowItWorks />
        <CustomerFilter />
        <Reviews />
        <CallToAction />
        <FAQ />
        <Footer />
        <FloatingWhatsApp />
      </div>
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          
          {/* Pagine quartieri prima espansione */}
          <Route path="/assistenza-condizionatori-roma" element={<AssistenzaCondizionatoriRoma />} />
          <Route path="/idraulico-roma-nord-parioli" element={<IdraulicoRomaNordParioli />} />
          <Route path="/pronto-intervento-roma-centro-ztl" element={<ProntoInterventoRomaCentroZTL />} />
          <Route path="/elettricista-roma-eur" element={<ElettricististaRomaEUR />} />
          <Route path="/riparazioni-caldaie-prati" element={<RiparazioniCaldaiePrati />} />
          
          {/* Pagine quartieri seconda espansione */}
          <Route path="/idraulico-roma-est-centocelle" element={<IdraulicoRomaEstCentocelle />} />
          <Route path="/pronto-intervento-monteverde" element={<ProntoInterventoMonteverde />} />
          <Route path="/elettricista-san-giovanni" element={<ElettricistaSanGiovanni />} />
          <Route path="/riparazioni-caldaie-aurelio" element={<RiparazioniCaldaieAurelio />} />
          <Route path="/sos-casa-trastevere-ztl" element={<SOSCasaTrastevereZTL />} />
          
          {/* Pagine servizio principali - alta conversione */}
          <Route path="/idraulico-roma-prati" element={<IdraulicoRomaPrati />} />
          <Route path="/idraulico-urgente-roma" element={<IdraulicoUrgenteRoma />} />
          <Route path="/elettricista-centro-roma" element={<ElettricistaCentroRoma />} />
          
          {/* Nuove pagine quartiere - conversione massima */}
          <Route path="/idraulico-roma-eur" element={<IdraulicoRomaEUR />} />
          <Route path="/idraulico-roma-parioli" element={<IdraulicoRomaParioli />} />
          <Route path="/idraulico-roma-trastevere" element={<IdraulicoRomaTrastevere />} />
          <Route path="/idraulico-roma-tiburtina" element={<IdraulicoRomaTiburtina />} />
          <Route path="/idraulico-roma-casilina" element={<IdraulicoRomaCasilina />} />
          <Route path="/elettricista-roma-nord" element={<ElettricistRomaNord />} />
          <Route path="/elettricista-roma-sud" element={<ElettricistRomaSud />} />
          <Route path="/pronto-intervento-roma-centro" element={<ProntoInterventoRomaCentro />} />
          <Route path="/pronto-intervento-roma-nord" element={<ProntoInterventoRomaNord />} />
          <Route path="/pronto-intervento-roma-sud" element={<ProntoInterventoRomaSud />} />
          
          {/* Articoli blog */}
          <Route path="/blog/come-sbloccare-galleggiante-geberit" element={<BlogGalleggianteGeberit />} />
          <Route path="/blog/caldaia-errore-e01-cosa-fare" element={<BlogCaldaiaErroreE01 />} />
          <Route path="/blog/perdita-acqua-lavandino-guida" element={<BlogPerditaAcquaLavandino />} />
          <Route path="/blog/pulire-filtri-condizionatore" element={<BlogPuliziaFiltriCondizionatore />} />
          <Route path="/blog/salvavita-scatta-quando-piove" element={<BlogSalvavitaPiove />} />
          
          {/* Nuovi articoli blog - alta conversione */}
          <Route path="/blog/perdita-acqua-cosa-fare-roma" element={<BlogPerditaAcquaCosaFare />} />
          <Route path="/blog/caldaia-rotta-cosa-fare" element={<BlogCaldaiaRottaCosaFare />} />
          <Route path="/blog/salvavita-scatta-cosa-fare" element={<BlogSalvavitaScattaCosaFare />} />
          
          {/* Redirect old URLs to canonical */}
          <Route path="/index.html" element={<Navigate to="/" replace />} />
          <Route path="/home" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
